import axios from 'axios';
import { getHostname } from './server/server';

const hostname = getHostname();
const path = '/v2/zoneLive';

async function getZoneLive(customerId, zoneId) {
    try {
        const res = await axios.get(`${hostname}${path}?customerId=${customerId}&zoneId=${zoneId}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 404) {
            return {};
        }
        throw err;
    }
}

async function getZoneLives(customerId) {
    const res = await axios.get(`${hostname}${path}/zoneLives?customerId=${customerId}`);
    return res.data;
}

export {
    getZoneLives,
    getZoneLive
}